import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class VaporPressureAttribute extends Sensor {
  public vaporPressureChart: any;
  private vaporPressureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.vaporPressureChart = null;
    this.vaporPressureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.vaporPressureSensor, position);
      this.vaporPressureSensor[position].push([timestamp, element.vaporPressure]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredVaporPressure = this.vaporPressureSensor.filter(series => series.length > 0);

    const positionNodeVaporPressure = this.vaporPressureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.vaporPressureChart = this.getConfigChar(
      'vaporPressure',
      this.getChartSeriesNewNode('Sensor', filteredVaporPressure, positionNodeVaporPressure),
      this.getRanges('vaporPressure'),
      this.getLimits('vaporPressure')
    );
  }

  public hasVaporPressureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.vaporPressureSensor.length &&
      this.vaporPressureSensor[index].length > 0
    );
  }

  public getVaporPressureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.vaporPressureSensor.length) {
      const sensorData = this.vaporPressureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Presión de Vapor', value: 'vaporPressure' }
    ];
  }
}
